import script from "./LangSwitchCom.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSwitchCom.vue?vue&type=script&setup=true&lang=js"

import "./LangSwitchCom.vue?vue&type=style&index=0&id=c390287e&lang=css"

const __exports__ = script;

export default __exports__